import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancellationTransactionModalComponent } from './cancellation-transaction-modal/cancellation-transaction-modal.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TokenCalculatorModalComponent } from './token-calculator-modal/token-calculator-modal.component';
import { ReferalModalComponent } from './referal-modal/referal-modal.component';
import { FormsModule } from '@angular/forms';
import { ProcessTransactionComponent } from './process-transaction/process-transaction.component';



@NgModule({
  declarations: [
    CancellationTransactionModalComponent,
    TokenCalculatorModalComponent,
    ReferalModalComponent,
    ProcessTransactionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TranslateModule
  ],
  exports: [
    CancellationTransactionModalComponent,
    TokenCalculatorModalComponent,
    ReferalModalComponent,
    ProcessTransactionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ModalsModule { }
